module.exports = __webpack_public_path__ + "assets/img/0.fd3ba676.png";